var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"content"},[_c('header',[_c('e-row',{attrs:{"mr":""}},[_c('e-col',[_c('h2',{staticClass:"component-title"},[_vm._v("Fila de Formalização de Vendas do Leilão")])]),_c('e-col',{staticClass:"text-right"})],1)],1),_c('div',{staticClass:"body"},[_c('fila-vendas-leiloes',{attrs:{"leilao":_vm.leilao}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }